import { formatDate } from "@clipboard-health/date-time";
import { isDefined } from "@clipboard-health/util-ts";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { useRequirementDetailsContext } from "../useRequirementDetailsContext";

/**
 * Shows upload status for a document requirement.
 * Displays the uploaded date if a document exists, otherwise prompts the user to upload.
 *
 * Currently used in the TB Test guided upload page. Can be adapted for other document detail pages.
 */
export function DocumentDetailsUploadStatus() {
  const { requirement: workerRequirement } = useRequirementDetailsContext();
  const { documents, requirement } = workerRequirement;
  const { name } = requirement?.attributes ?? {};
  const uploadedDate = documents?.[0]?.attributes?.createdAt;

  const text = isDefined(uploadedDate)
    ? `Uploaded ${formatDate(new Date(uploadedDate))}`
    : `Please upload your latest ${name ?? "document"}`;

  return (
    <Text variant="body1" sx={{ color: (theme) => theme.palette.text.secondary }}>
      {text}
    </Text>
  );
}
